import React from "react";
import useSizePercentage from "../hooks/useSizePercentage";
import MainStore from "../stores/MainStore";
import { Box } from "./Box";

const DisplayedBoxes = () => {
  const { displayedBoxes } = MainStore();
  const sizePercentage = useSizePercentage();
  return (
    <div
      className="divRow"
      style={{
        display: "flex",
        flexWrap: "wrap",
        maxHeight: `${(700 / 100) * sizePercentage.height}px`,
        overflow: "auto",
        justifyContent: "center",
      }}
    >
      {displayedBoxes.map((object, index) => (
        <div style={{ margin: "10px" }} key={index}>
          <Box type={object.type} object={object.object} from={object.from} />
        </div>
      ))}
    </div>
  );
};

export default DisplayedBoxes;
